import React, { useState, useLayoutEffect } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { styleBreakMobile } from '../utilities/layouts/Globals';
import { CardItem } from '../utilities/commonUtilities/CardItem';
import { ReactComponent as ImagingBadge } from '../../resources/images/imaging-big-badge.svg';
import TutorialCalendarLayout from './TutorialCalendarLayout';
import TutorialFloatingGrid from './TutorialFloatingGrid';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    tutorialContent: {
        marginTop: theme.spacing(12.5),
        paddingLeft: theme.spacing(7) - 1,
        paddingRight: theme.spacing(7) - 1,
        marginBottom: theme.spacing(12.5),
        width: '100%',
        maxWidth: theme.spacing(160),
        marginLeft: 'auto',
        marginRight: 'auto',
        [styleBreakMobile(theme)]: {
            marginTop: theme.spacing(4),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    },
    mobileFinalContentHeader: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        letterSpacing: theme.spacing(0.03),
        fontSize: theme.spacing(2) + 1,
    },
    mobileFinalContentBody: {
        marginBottom: theme.spacing(3),
        pointerEvents: 'none',
    },
}));

export default function CalendarTutorial({ tutorialCurrentPage, isMobile, type }) {
    const classes = useStyles();
    const [mobileFinalContent, setMobileFinalContent] = useState(false);

    const title = 'Calendar';
    const dateOfDiagnosis = moment('2021-08-01');
    const endOfTreatementDate = isMobile ? moment('2030-08-25') : moment('2026-08-30');
    const seminomaLabel = 'Stage 1 Non-Seminoma Surveillance';

    useLayoutEffect(() => {
        isMobile && tutorialCurrentPage === 3 ? setMobileFinalContent(true) : setMobileFinalContent(false);
    }, [isMobile, tutorialCurrentPage]);

    const multiPageInfo = {
        2: {
            title: 'Calendar Overview',
            body: 'This will give you a quick view of where you are in your journey.',
            lPadding: '0%',
        },
        3: {
            title: isMobile ? 'Upcoming Appointments' : 'Download Calendar',
            body: isMobile
                ? "Underneath your calendar overview you'll see a list of all your upcoming appointments. you can tap into these to see more information."
                : 'Click here to download your upcoming visits to your device.',
            lPadding: isMobile ? '0%' : 'calc(100% - 672px)',
        },
        4: {
            title: 'Print Calendar',
            body: 'Click here to print a calendar of your upcoming visits.',
            lPadding: 'calc(100% - 624px)',
        },
        5: {
            title: 'Calendar Information',
            body: 'Click here for more information about the Calendar icons.',
            lPadding: 'calc(100% - 520px)',
        },
        6: {
            title: 'Calendar Information',
            body: 'Click here for more information about the Calendar icons.',
            lPadding: 'calc(100% - 800px)',
        },
        7: {
            title: 'Past Month',
            body: 'Boxes that are greyed represent months that have passed.',
        },
        8: {
            title: 'Current Month',
            body: 'The current month of your surveillance journey will be highlighted.',
        },
        9: {
            title: 'Start Date (Date of Diagnosis)',
            body: 'This icon shows the start date of your surveillance journey.',
        },
        10: {
            title: 'Imaging Test',
            body: 'This icon shows when you have an imaging test. You can click on this icon to see more information.',
        },
        11: {
            title: 'Blood Test',
            body: 'This icon shows when you have a blood test. You can click on this icon to see more information.',
        },
        12: {
            title: 'End of Surveillance',
            body: 'This icon marks the completion of your surveillance journey!',
        },
    };

    return (
        <Box className={classes.tutorialContent}>
            {!mobileFinalContent ? (
                <>
                    <Typography variant="h1" style={{ opacity: isMobile || tutorialCurrentPage === 2 ? 1 : 0.4 }}>
                        {title}
                    </Typography>
                    <TutorialCalendarLayout
                        tutorialCurrentPage={tutorialCurrentPage}
                        dateOfDiagnosis={dateOfDiagnosis}
                        endOfTreatementDate={endOfTreatementDate}
                        stage={seminomaLabel}
                        complexGridInfo={multiPageInfo}
                        type={type}
                    />
                </>
            ) : (
                <>
                    <Typography className={classes.mobileFinalContentHeader}>Year 1</Typography>
                    <CardItem className={classes.mobileFinalContentBody} title={'Get an Imaging Test'} Badge={ImagingBadge} subtitle={'Dec 2022'} />
                </>
            )}
            {tutorialCurrentPage <= 6 && (
                <TutorialFloatingGrid tutorialCurrentPage={tutorialCurrentPage} complexGridInfo={multiPageInfo} isMobile={isMobile} type={type} />
            )}
        </Box>
    );
}
